import Vue from 'vue'
import Router from 'vue-router'
import CallerView from '@/views/CallerView'
import Login from '@/views/Login'
import Dashboard from '@/views/Dashboard'
import CallList from '@/views/CallList'
import CaseDetails from '@/views/CaseDetails'
import store from '@/store'

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isLoggedIn) {
    next()
    return
  }
  next('/')
}

export default new Router({
  routes: [
    {
      path: '/:mobile/:processname/:sip',
      name: 'CallerView',
      component: CallerView,
      props: true
    },
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/calllist',
      name: 'CallList',
      component: CallList,
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/casedetails',
      name: 'CaseDetails',
      component: CaseDetails,
      props: true,
      beforeEnter: ifAuthenticated
    }
  ]
})